export default __webpack_public_path__ + "static/media/miscellaneous13.4998eac1.png";